import { render, staticRenderFns } from "./ModalSelectDataPerizia.vue?vue&type=template&id=ec6c28ee"
import script from "./ModalSelectDataPerizia.vue?vue&type=script&lang=js"
export * from "./ModalSelectDataPerizia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports